<div class="add-TaxData-container padding-content-dialog" *ngIf="showModal">
  <div class="header-add-TaxData">
    <div class="header-title font-omicron-bold color-black-detail-omicron">
      <p class="mb-0 title-size-1">Envases</p>

      <span matDialogClose class="cursor-pointer">
        <svg xmlns="http://www.w3.org/2000/svg" width="15.6" height="15.598" viewBox="0 0 15.6 15.598">
          <path
            d="M23.137,8.2a1.13,1.13,0,0,0-1.6,0l-5.866,5.866L9.8,8.2A1.131,1.131,0,0,0,8.2,9.8l5.866,5.866L8.2,21.537a1.131,1.131,0,0,0,1.6,1.6l5.863-5.863,5.866,5.866a1.131,1.131,0,1,0,1.6-1.6l-5.87-5.87L23.137,9.8A1.135,1.135,0,0,0,23.137,8.2Z"
            transform="translate(-7.873 -7.872)" />
        </svg>
      </span>
    </div>
  </div>

  <mat-dialog-content class="mat-typography content-dialogs-scroll">
    <div class="jars-container">
      <div class="container-image-selected">
        <img [src]="activeContainer.imageUrl" [alt]="activeContainer.description" *ngIf="
            activeContainer.imageUrl !== '' &&
            activeContainer.imageUrl !== undefined &&
            activeContainer.imageUrl !== null
          " />
        <img src="./assets/icons/no-image.svg" alt="no image" *ngIf="
            activeContainer.imageUrl === '' ||
            activeContainer.imageUrl === undefined ||
            activeContainer.imageUrl === null
          " />
      </div>
      <div class="containers-list-content">
        <mat-radio-group class="mat-radio-group radio-content" ngDefaultControl [(ngModel)]="activeContainer">
          <mat-radio-button id="{{'check-'+ container.description | lowercase }}" [value]="container" *ngFor="let container of containers">
            <p class="mb-0 font-omicron-medium text-size-1" [ngClass]="
                activeContainer.description === container.description
                  ? 'color-omicron'
                  : ''
              " *ngIf="
                container.priceWithIVA > 0 &&
                container.priceWithIVA !== container.priceWithIvaDiscount
              ">
              {{ container.description }} +
              <span class="discount font-omicron-bold text-size-1">
                ${{ container.priceWithIVA | numberNotRound }} MXN
              </span>
              <span class="font-omicron-bold text-size-1">
                ${{ container.priceWithIvaDiscount | numberNotRound }} MXN
              </span>
              <span class="
                  not-available-color
                  font-omicron-bold
                  text-size-legends" *ngIf="container.containerHasMissing && !container.arriveDateContainer && data.showMissingMesages"> Agotado temporalmente</span>
              <span class="
                not-available-color
                font-omicron-bold
                text-size-legends
              " *ngIf="container.containerHasMissing && container.arriveDateContainer && data.showMissingMesages">Disponible apróx. a partir del
                {{ container.arriveDateContainer | date: 'dd MMM':'MX' | titlecase}}</span>
            </p>
            <p class="mb-0 font-omicron-medium text-size-1" [ngClass]="
                activeContainer.description === container.description
                  ? 'color-omicron'
                  : ''
              " *ngIf="
                container.priceWithIVA > 0 &&
                container.priceWithIVA === container.priceWithIvaDiscount
              ">
              {{ container.description }} +
              <span class="font-omicron-bold text-size-1">
                ${{ container.priceWithIvaDiscount | numberNotRound }} MXN
              </span>
              <span class="not-available-color
              font-omicron-bold
              text-size-legends" *ngIf="container.containerHasMissing && !container.arriveDateContainer && data.showMissingMesages"> Agotado temporalmente</span>
              <span class="not-available-color
              font-omicron-bold
              text-size-legends" *ngIf="container.containerHasMissing && container.arriveDateContainer && data.showMissingMesages">Disponible
                apróx. a
                partir del
                {{ container.arriveDateContainer | date: 'dd MMM':'MX' | titlecase}}</span>
            </p>
            <p class="mb-0 font-omicron-medium text-size-1" [ngClass]="
                activeContainer.description === container.description
                  ? 'color-omicron'
                  : ''
              " *ngIf="container.priceWithIVA <= 0">
              {{ container.description }}
              <span class="
                not-available-color
                font-omicron-bold
                text-size-legends
                " *ngIf="container.containerHasMissing && !container.arriveDateContainer && data.showMissingMesages">Agotado temporalmente</span>
              <span class="
                not-available-color
                font-omicron-bold
                text-size-legends
              " *ngIf="container.containerHasMissing && container.arriveDateContainer && data.showMissingMesages">Disponible apróx. a partir del
                {{ container.arriveDateContainer | date: 'dd MMM':'MX' | titlecase}}</span>
            </p>
          </mat-radio-button>
        </mat-radio-group>
        <div class="select-container-content">
          <mat-form-field appearance="outline" class="select-input-container">
            <mat-select [(ngModel)]="activeContainer" name="select">
              <mat-option *ngFor="let container of containers" [value]="container">
                <p class="mb-0 font-omicron-medium text-size-1" [ngClass]="
                    activeContainer.description === container.description
                      ? 'color-omicron'
                      : ''
                  " *ngIf="
                    container.priceWithIVA > 0 &&
                    container.priceWithIVA !== container.priceWithIvaDiscount
                  ">
                  {{ container.description }} +
                  <span class="discount font-omicron-bold text-size-1">
                    ${{ container.priceWithIVA | numberNotRound }} MXN
                  </span>
                  <span class="font-omicron-bold text-size-1">
                    ${{ container.priceWithIvaDiscount | numberNotRound }} MXN
                  </span>
                  <span class="
                    not-available-color
                    font-omicron-bold
                    text-size-legends
                    " *ngIf="container.containerHasMissing && !container.arriveDateContainer && data.showMissingMesages">Agotado temporalmente</span>
                  <span class="
                    not-available-color
                    font-omicron-bold
                    text-size-legends
                  " *ngIf="container.containerHasMissing && container.arriveDateContainer && data.showMissingMesages">Disponible apróx. a partir
                    del
                    {{ container.arriveDateContainer | date: 'dd MMM':'MX' | titlecase}}</span>
                </p>
                <p class="mb-0 font-omicron-medium text-size-1" [ngClass]="
                    activeContainer.description === container.description
                      ? 'color-omicron'
                      : ''
                  " *ngIf="
                    container.priceWithIVA > 0 &&
                    container.priceWithIVA === container.priceWithIvaDiscount
                  ">
                  {{ container.description }} +
                  <span class="font-omicron-bold text-size-1">
                    ${{ container.priceWithIvaDiscount | numberNotRound }} MXN
                  </span>
                  <span class="
                  not-available-color
                  font-omicron-bold
                  text-size-legends
                  " *ngIf="container.containerHasMissing && !container.arriveDateContainer && data.showMissingMesages"> Agotado temporalmente</span>
                  <span class="
                  not-available-color
                  font-omicron-bold
                  text-size-legends
                " *ngIf="container.containerHasMissing && container.arriveDateContainer && data.showMissingMesages">Disponible apróx. a partir del
                    {{ container.arriveDateContainer | date: 'dd MMM':'MX' | titlecase}}</span>
                </p>
                <p class="mb-0 font-omicron-medium text-size-1" [ngClass]="
                    activeContainer.description === container.description
                      ? 'color-omicron'
                      : ''
                  " *ngIf="container.priceWithIVA <= 0">
                  {{ container.description }}
                  <span class="
                  not-available-color
                  font-omicron-bold
                  text-size-legends
                  " *ngIf="container.containerHasMissing && !container.arriveDateContainer && data.showMissingMesages">Agotado temporalmente</span>
                  <span class="
                  not-available-color
                  font-omicron-bold
                  text-size-legends
                " *ngIf="container.containerHasMissing && container.arriveDateContainer && data.showMissingMesages">Disponible apróx. a partir del
                    {{ container.arriveDateContainer | date: 'dd MMM':'MX' | titlecase}}</span>
                </p>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="botton-title">
      <button mat-stroked-button class="
          button-container
          font-size-button
          white-button
          d-flex
          flex-nowrap
        " color="primary" matDialogClose>
        Cancelar
      </button>
      <button mat-raised-button class="blue-button radius-button font-size-button blue-button mt-3" type="submit"
        color="primary" [disabled]="activeContainer.description === ''" (click)="accept()">
        Aceptar
      </button>
    </div>
  </mat-dialog-actions>
</div>